import React from 'react';
import { Form, Select, InputNumber, Input } from 'antd';
import { validateCurrency } from '../../utils/validation';

const { Option } = Select;

const TyraFormFields = () => (
  <>
    <Form.Item
      name="name"
      label="Nome"
      className="form-item"
      rules={[{ required: true, message: 'Campo obrigatório!' }]}
    >
      <Input />
    </Form.Item>
    <Form.Item
      name="subcategory"
      label="Subcategoria"
      className="select form-item"
      rules={[{ required: true, message: 'Campo obrigatório!' }]}
    >
      <Select rules={[{ required: true, message: 'Campo obrigatório!' }]}>
        <Option value="TYRA">Tyra</Option>
        <Option value="TYRA_MARKET">Tyra + Market</Option>
      </Select>
    </Form.Item>

    <Form.Item
      name="value"
      label="Valor"
      className="form-item"
      rules={[
        { required: true, message: 'Campo obrigatório!' },
        { validator: validateCurrency },
      ]}
    >
      <Input />
    </Form.Item>
  </>
);

export default TyraFormFields;
